'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var APIVERSION = null;

var Licenses = function Licenses(baseUrl, version, axios) {

    APIVERSION = '/' + version;

    return {

        createLicence: function createLicence(payload) {

            var object = { company: payload.company, app: payload.apps, totalSeats: payload.totalSeats };
            return axios.put(APIVERSION + '/companies/' + payload.company + '/applicenses', object).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        updateLicence: function updateLicence(payload) {
            if (!payload.license) {
                return 'Missing licence ID, cannot update';
            }
            var object = { id: payload.license, company: payload.company, app: payload.apps, totalSeats: payload.totalSeats };
            return axios.put(APIVERSION + '/companies/' + payload.company + '/applicenses', object).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        getLicenses: function getLicenses(COMPANY_ID) {

            return axios.get(APIVERSION + '/companies/' + COMPANY_ID + '/applicenses').catch(function (error) {
                return Promise.reject(error);
            }).then(function (res) {
                if (res.status == 200) {
                    return Promise.resolve(res);
                } else {}
            });
        },

        getLicence: function getLicence(COMPANY_ID) {
            return axios.get(APIVERSION + '/licences/' + COMPANY_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                return e;
            });
        },

        deleteLicenses: function deleteLicenses(COMPANY_ID, APP_ID) {
            return axios.delete(APIVERSION + '/companies/' + COMPANY_ID + '/applicenses/' + APP_ID).then(function (res) {
                return res;
            }).catch(function (e) {
                e;
            });
        }
    };
};
exports.default = Licenses;


function checkForRequiredValues(arrayOFValuesRequired, ObjectPassed) {
    var result = true;
    arrayOFValuesRequired.forEach(function (check) {
        var test = _.includes(check, ObjectPassed);
        if (!test) {
            result = false;
        }
    });
    return result;
}